// ======================================================================
// FILE: src/modules/campaign/dashboard/pages/CampaignDashboardPage.jsx
// MODULE: Campaign Management
// PURPOSE:
//   Campaign Dashboard
// ======================================================================

import React from "react";

export default function CampaignDashboardPage() {

    return (

        <div className="container-fluid">

            <div className="card shadow-sm">

                <div className="card-body">

                    <h3 className="mb-3">
                        Campaign Dashboard
                    </h3>

                    <p className="text-muted mb-0">
                        Campaign Dashboard is under development.
                    </p>

                </div>

            </div>

        </div>

    );

}